"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const event_fragment_1 = __importDefault(require("../fragments/event.fragment"));
// This one is for the recent orders card on the customer overview page in backstage.
const query = (0, client_1.gql) `
  query orders($query: OrderQueryInput, $pagination: PaginationInput) {
    orders(query: $query, pagination: $pagination) {
      _id
      event {
        _id
        name
        subtitle
        posterImageUrl
        hasOrders
        schedule {
          startsAt
        }
        venue {
          name
          address {
            state
            city
          }
        }
        published
        ...EventSchedule
        ...TicketTypes
        ...EventUpgrades
        ...WebFlowEntity
      }
    }
  }

  ${event_fragment_1.default.fragments.schedule}
  ${event_fragment_1.default.fragments.ticketTypes}
  ${event_fragment_1.default.fragments.upgrades}
  ${event_fragment_1.default.fragments.webFlowEntity}
`;
exports.default = query;
//# sourceMappingURL=customerOrders.query.js.map